module.exports = __webpack_public_path__ + "assets/img/img36.b972eb73.png";